import { URL_ROOT} from '../config/settings';

//MAIN ROUTES
export const ROOT_URL= "/"+URL_ROOT;
export const MAIN = ROOT_URL;
export const LOGIN = MAIN+"/login";
